import { isObservable, mix, observable } from "@chorda/core";
import { Icon } from "chorda-bulma";
const isIconDefinition = (icon) => {
    return !!icon.iconName;
};
export const FaIcon = (props) => {
    const prefix = (props === null || props === void 0 ? void 0 : props.prefix) || 'fas';
    return mix(Icon, {
        tag: 'i',
        templates: {
            icon: {
                reactions: {
                    data: (next, prev) => {
                        //                        console.log('icon', next, prev)
                        const classes = {};
                        if (next) {
                            if (isObservable(next)) {
                                next = next.$value;
                            }
                            (Array.isArray(next) ? next : [next]).forEach(s => {
                                if (isIconDefinition(s)) {
                                    classes['fa-' + s.iconName] = true;
                                    classes[s.prefix] = true;
                                }
                                else {
                                    classes['fa-' + s] = true;
                                    classes[prefix] = true;
                                }
                            });
                        }
                        if (prev) {
                            if (isObservable(prev)) {
                                prev = prev.$value;
                            }
                            (Array.isArray(prev) ? prev : [prev]).forEach(s => {
                                if (isIconDefinition(s)) {
                                    classes['fa-' + s.iconName] = false;
                                    classes[s.prefix] = classes[s.prefix] || false;
                                }
                                else {
                                    classes['fa-' + s] = false;
                                    classes[prefix] = classes[prefix] || false;
                                }
                            });
                            //                            (Array.isArray(prev) ? prev : [prev]).map(s => s.iconName || s).forEach(s => classes[prefix+'-'+s] = false)
                        }
                        //                        console.log('icon', classes)
                        // next = next ? (prefix+'-'+next) : next
                        // prev = prev ? (prefix+'-'+prev) : prev
                        return { classes }; //: {[next]: true, [prev]: false}})
                    }
                }
            }
        }
    }, props === null || props === void 0 ? void 0 : props.as, props && {
        defaults: {
            data: () => observable(props.icon)
        },
        injections: {
            data: props.icon$
        }
    });
};
